import React, {useState} from 'react';

import styles from './LoginOrSignIn.module.css'
import {Input} from "../../../../ui/DataEntry/Input/Input.tsx";
import {Button} from "../../../../ui/General/Button/Button.tsx";
import {cn} from "../../../../utils/cn.ts";
import {formatPhone} from "../../../../utils/formatters/index.ts";
import {Loader} from "../../../../ui/Loader/Loader.tsx";

interface Props {
    onAuth: (isAuth: boolean) => void
    onPhoneChange: (phone: string) => void,
    phoneNumber: string,
    isFailedAttempt: boolean,
    isSendPassword: boolean,
    onPassAndPhoneLogin: (phone: string, password: string) => void,
    onLoggedOrSignedIn: (signIn: boolean) => void,
}

export const LoginOrSignIn: React.FC<Props> = ({
                                                   onAuth,
                                                   onPhoneChange,
                                                   phoneNumber,
                                                   isFailedAttempt,
                                                   onPassAndPhoneLogin,
                                                   onLoggedOrSignedIn,
                                                   isSendPassword,
                                               }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [pass, setPass] = useState('');
    const handleLogin = () => {
        setIsLoading(true);
        onPassAndPhoneLogin(phoneNumber, pass);
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.hedaer}>
                <h4 className={styles.title}>Войти или <span className={styles.regLink}
                                                             onClick={() => onAuth(false)}>зарегистрироваться</span>
                </h4>
            </div>
            {isSendPassword && (<div className={styles.hedaer}>
                <h4 className={styles.restoreText}>Пароль отправлен в Whatsapp на указанный телефон</h4>
            </div>)}
            <div className={styles.body}>
                {isFailedAttempt && (
                    <div className={styles.invalidInputText}>
                        <div>Введен неверный логин или пароль.</div>
                        <div>Пожалуйста, проверьте введенные данные.</div>
                    </div>
                )}
                <Input
                    disabled={isLoading && !isFailedAttempt}
                    hasBorder
                    placeholder='Номер телефона'
                    value={formatPhone(phoneNumber)}
                    changeStateValue={onPhoneChange}
                />
                <Input
                    disabled={isLoading && !isFailedAttempt}
                    className={cn(styles.input, isFailedAttempt && styles.invalidInput)}
                    type='password'
                    hasBorder
                    placeholder='Пароль'
                    changeStateValue={setPass}
                />
                <Button
                    className={styles.btn}
                    onClick={handleLogin}
                >
                    {isLoading && !isFailedAttempt ? <><Loader /> Войти</> : <>Войти</>}
                </Button>
                <Button className={styles.btn} onClick={() => {
                    onLoggedOrSignedIn(true);
                    onAuth(false);
                }}>
                    Забыли пароль
                </Button>
            </div>
        </div>
    );
};
